module.exports = __webpack_public_path__ + "static/media/plus-icon.5f9a01c5.svg";